/**
 * Money.
 *
 * Every item has carried a `sellPrice` since Phase 3 and nothing has ever
 * spent or earned one. This is the other half of that.
 *
 * Deliberately a plain integer with no debt and no overdraft: a cozy game
 * where you can owe money is a different game, and every refusal here is
 * "you cannot afford that" rather than a consequence to be managed later.
 */
export class Wallet {
  private value: number;

  constructor(starting = 0) {
    this.value = Math.max(0, Math.floor(starting));
  }

  get coins(): number {
    return this.value;
  }

  earn(amount: number): void {
    if (amount <= 0) return;
    this.value += Math.floor(amount);
  }

  canAfford(amount: number): boolean {
    return amount >= 0 && this.value >= amount;
  }

  /** Spend, or return false and spend nothing. */
  spend(amount: number): boolean {
    if (!this.canAfford(amount)) return false;
    this.value -= Math.floor(amount);
    return true;
  }

  toSave(): number {
    return this.value;
  }

  static fromSave(value: unknown): Wallet {
    const coins = Math.floor(Number(value));
    return new Wallet(Number.isFinite(coins) ? coins : 0);
  }
}
